export default __webpack_public_path__ + "static/media/DSC_7434.7845a294.jpg";